import { getIsMobile } from '../../../utils/getIsMobile';
import { useShowBottomStub } from './hooks/useShowBottomStub';
import { StubContainerBottom, StubContainerTop } from './styles';

/**
 * Заглушка для подкрашивания нижней панели в ПП INSPIRE-7052
 */
export const SearchAppPanelStub = () => {
    const { isMobile } = getIsMobile();
    const showBottomStub = useShowBottomStub();

    if (!isMobile) {
        return null;
    }

    if (!showBottomStub) {
        return <StubContainerTop />;
    }

    return (
        <>
            <StubContainerTop />
            <StubContainerBottom />
        </>
    );
};
